import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
const useGetStockStatusLabel = (identifier, quantity) => {
  const { getLabel, getFormattedLabel } = useIntl();
  return React.useMemo(() => {
    const labelMap = {
      "in-stock": () => getLabel("common.stockIndicator.inStock"),
      "in-stock-with-quantity": (quantity2) => getFormattedLabel("common.stockIndicator.inStockWithQuantity", {
        labelData: { quantity: quantity2?.toString() }
      }),
      "low-stock": () => getLabel("common.stockIndicator.lowStock"),
      "low-stock-with-quantity": (quantity2) => getFormattedLabel("common.stockIndicator.lowStockWithQuantity", {
        labelData: { quantity: quantity2?.toString() }
      }),
      "out-of-stock": () => getLabel("common.stockIndicator.outOfStock"),
      "out-of-stock-with-back-order": () => getLabel("common.stockIndicator.backOrder"),
      "unknown-stock": () => getLabel("common.stockIndicator.unknownStock")
    };
    const label = labelMap[identifier];
    return label(quantity);
  }, [getFormattedLabel, getLabel, quantity, identifier]);
};
export {
  useGetStockStatusLabel
};
//# sourceMappingURL=useGetStockStatusLabel.js.map
